import { jsx } from '@emotion/react';
import { Button } from '../Button/Button.es.js';
import { DarkBackgroundButton } from '../DarkBackgroundButton/DarkBackgroundButton.es.js';
import { IconButton } from '../IconButton/IconButton.es.js';
import { DarkBackgroundIconButton } from '../DarkBackgroundIconButton/DarkBackgroundIconButton.es.js';

const BackButton = ({ ariaLabel, children, href, isOnDarkBackground, onClick, size = "small", tooltipText }) => {
  const sharedProps = {
    ariaLabel,
    href,
    onClick
  };
  const ButtonComponent = isOnDarkBackground ? DarkBackgroundButton : Button;
  if (children) {
    return jsx(ButtonComponent, Object.assign({}, sharedProps, { color: "secondary", iconBefore: "arrowBigLeft", size }), children);
  } else {
    if (isOnDarkBackground) {
      return jsx(DarkBackgroundIconButton, Object.assign({}, sharedProps, { color: "icon-secondary", icon: "arrowBigLeft", label: tooltipText, tooltipPosition: "east" }));
    } else {
      return jsx(IconButton, Object.assign({}, sharedProps, { color: "icon-alt", icon: "arrowBigLeft", label: tooltipText, tooltipPosition: "east" }));
    }
  }
};

export { BackButton };
//# sourceMappingURL=BackButton.es.js.map
